import { save as Xt } from "@tauri-apps/plugin-dialog";
import { writeTextFile as Jt, writeFile as Yt } from "@tauri-apps/plugin-fs";
import { open as Qt } from "@tauri-apps/plugin-shell";
import ge from "axios";
function Je(t, e, n, r, s, a, i, o, u) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return e(t);
    case 3:
      return n(e(t));
    case 4:
      return r(n(e(t)));
    case 5:
      return s(r(n(e(t))));
    case 6:
      return a(s(r(n(e(t)))));
    case 7:
      return i(a(s(r(n(e(t))))));
    case 8:
      return o(i(a(s(r(n(e(t)))))));
    case 9:
      return u(o(i(a(s(r(n(e(t))))))));
    default: {
      for (var d = arguments[0], m = 1; m < arguments.length; m++)
        d = arguments[m](d);
      return d;
    }
  }
}
var qt = { _tag: "None" }, en = function(t) {
  return { _tag: "Some", value: t };
}, tn = function(t) {
  return t._tag === "Left";
}, nn = function(t) {
  return t._tag === "Right";
}, rn = function(t) {
  return { _tag: "Left", left: t };
}, sn = function(t) {
  return { _tag: "Right", right: t };
}, an = function(t) {
  return t.length > 0;
}, on = function(t) {
  return t[0];
}, bt = Object.prototype.hasOwnProperty, cn = an, un = on, Qe = un, dn = function(t) {
  return t[t.length - 1];
}, Pe = function(t) {
  return function(e) {
    var n = e.split(t);
    return cn(n) ? n : [e];
  };
};
const ln = {
  api: {
    async saveFileWithDialog(t) {
      const e = new Blob([t.data], { type: t.contentType }), n = document.createElement("a"), r = URL.createObjectURL(e);
      return n.href = r, n.download = t.suggestedFilename ?? Je(
        r,
        Pe("/"),
        dn,
        Pe("#"),
        Qe,
        Pe("?"),
        Qe
      ), document.body.appendChild(n), n.click(), setTimeout(() => {
        document.body.removeChild(n), URL.revokeObjectURL(r);
      }, 1e3), { type: "unknown" };
    },
    async openExternalLink(t) {
      return window.open(t.url, "_blank"), { type: "unknown" };
    },
    async listen(t, e) {
      const n = (r) => {
        const s = window.location.hash;
        if (s && s.startsWith(`#${t}:`)) {
          const a = s.slice(t.length + 2);
          e({
            event: t,
            id: Date.now(),
            payload: JSON.parse(a)
          });
        }
      };
      return window.addEventListener("hashchange", n), () => window.removeEventListener("hashchange", n);
    },
    async once(t, e) {
      const n = (r) => {
        const s = window.location.hash;
        if (s && s.startsWith(`#${t}:`)) {
          const a = s.slice(t.length + 2);
          window.removeEventListener("hashchange", n), e({
            event: t,
            id: Date.now(),
            payload: JSON.parse(a)
          });
        }
      };
      return window.addEventListener("hashchange", n), () => window.removeEventListener("hashchange", n);
    },
    async emit(t, e) {
      window.location.hash = `${t}:${JSON.stringify(e)}`;
    }
  }
}, fn = {
  v1: ln
};
function St(t, e = !1) {
  return window.__TAURI_INTERNALS__.transformCallback(t, e);
}
async function Ne(t, e = {}, n) {
  return window.__TAURI_INTERNALS__.invoke(t, e, n);
}
const hn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  invoke: Ne,
  transformCallback: St
}, Symbol.toStringTag, { value: "Module" }));
var qe;
(function(t) {
  t.WINDOW_RESIZED = "tauri://resize", t.WINDOW_MOVED = "tauri://move", t.WINDOW_CLOSE_REQUESTED = "tauri://close-requested", t.WINDOW_DESTROYED = "tauri://destroyed", t.WINDOW_FOCUS = "tauri://focus", t.WINDOW_BLUR = "tauri://blur", t.WINDOW_SCALE_FACTOR_CHANGED = "tauri://scale-change", t.WINDOW_THEME_CHANGED = "tauri://theme-changed", t.WINDOW_CREATED = "tauri://window-created", t.WEBVIEW_CREATED = "tauri://webview-created", t.DRAG_ENTER = "tauri://drag-enter", t.DRAG_OVER = "tauri://drag-over", t.DRAG_DROP = "tauri://drag-drop", t.DRAG_LEAVE = "tauri://drag-leave";
})(qe || (qe = {}));
async function pn(t, e) {
  await Ne("plugin:event|unlisten", {
    event: t,
    eventId: e
  });
}
async function et(t, e, n) {
  var r;
  const s = (r = void 0) !== null && r !== void 0 ? r : { kind: "Any" };
  return Ne("plugin:event|listen", {
    event: t,
    target: s,
    handler: St(e)
  }).then((a) => async () => pn(t, a));
}
async function mn(t, e) {
  await Ne("plugin:event|emit", {
    event: t,
    payload: e
  });
}
const gn = {
  api: {
    async saveFileWithDialog(t) {
      const e = await Xt({
        filters: t.filters,
        defaultPath: t.suggestedFilename
      });
      return e ? (typeof t.data == "string" ? await Jt(e, t.data) : await Yt(e, t.data), { type: "saved", path: e }) : { type: "cancelled" };
    },
    async openExternalLink(t) {
      return await Qt(t.url), { type: "opened" };
    },
    async listen(t, e) {
      return await et(t, e);
    },
    async once(t, e) {
      const n = await et(t, (r) => {
        n(), e(r);
      });
      return n;
    },
    async emit(t, e) {
      await mn(t, e);
    }
  }
}, yn = {
  v1: gn
};
var w = rn, x = sn, $e = tn, _n = nn, vn = qt, wn = en, kn = function(t) {
  return t._tag === "None";
}, xn = function(t) {
  return function(e) {
    return kn(e) ? t() : e.value;
  };
}, bn = xn, Et = /* @__PURE__ */ ((t) => (t.TEXT_PLAIN = "text/plain", t.TEXT_HTML = "text/html", t.TEXT_CSS = "text/css", t.TEXT_CSV = "text/csv", t.APPLICATION_JSON = "application/json", t.APPLICATION_LD_JSON = "application/ld+json", t.APPLICATION_XML = "application/xml", t.TEXT_XML = "text/xml", t.APPLICATION_FORM = "application/x-www-form-urlencoded", t.APPLICATION_OCTET = "application/octet-stream", t.MULTIPART_FORM = "multipart/form-data", t))(Et || {});
const Ot = {
  body: (t, e) => ({
    body: new Uint8Array(t),
    mediaType: typeof e == "string" ? Object.values(Et).find((n) => e.includes(n)) ?? "application/octet-stream" : e ?? "application/octet-stream"
    /* APPLICATION_OCTET */
  })
}, Z = {
  text: (t) => t,
  json: (t) => t,
  xml: (t) => t,
  form: (t) => t,
  binary: (t) => t,
  multipart: (t) => t,
  stream: (t) => t,
  urlencoded: (t) => Je(
    t,
    (e) => typeof e == "string" ? wn(e) : vn,
    bn(() => {
      const e = new URLSearchParams();
      return Object.entries(t).filter(([r, s]) => s != null).forEach(([r, s]) => e.append(r, s.toString())), e.toString();
    })
  )
}, G = {
  /**
   * Creates text content. Useful for:
   * - Plain text
   * - Pre-stringified JSON (to avoid encoding escapes)
   * - Custom text formats
   */
  text: (t, e) => ({
    kind: "text",
    content: Z.text(t),
    mediaType: e ?? "text/plain"
    /* TEXT_PLAIN */
  }),
  /**
   * Creates JSON content with automatic serialization.
   * Note: If you already have a JSON string, consider using `text()`
   * with `APPLICATION_JSON` mediaType to avoid double-encoding.
   */
  json: (t, e) => ({
    kind: "json",
    content: Z.json(t),
    mediaType: e ?? "application/json"
    /* APPLICATION_JSON */
  }),
  /**
   * Creates XML content. Currently processed as text.
   */
  xml: (t, e) => ({
    kind: "xml",
    content: Z.xml(t),
    mediaType: e ?? "application/xml"
    /* APPLICATION_XML */
  }),
  /**
   * Creates form-encoded content from FormData.
   */
  form: (t, e) => ({
    kind: "form",
    content: Z.form(t),
    mediaType: e ?? "application/x-www-form-urlencoded"
    /* APPLICATION_FORM */
  }),
  /**
   * Creates binary content. Supports any binary format.
   */
  binary: (t, e = "application/octet-stream", n) => ({
    kind: "binary",
    content: Z.binary(t),
    mediaType: e,
    filename: n
  }),
  /**
   * Creates multipart form content with file upload support.
   */
  multipart: (t, e) => ({
    kind: "multipart",
    content: Z.multipart(t),
    mediaType: e ?? "multipart/form-data"
    /* MULTIPART_FORM */
  }),
  /**
   * Creates URL-encoded content from string or object.
   */
  urlencoded: (t, e) => ({
    kind: "urlencoded",
    content: Z.urlencoded(t),
    mediaType: e ?? "application/x-www-form-urlencoded"
    /* APPLICATION_FORM */
  }),
  /**
   * Creates streaming content for large payloads.
   */
  stream: (t, e) => ({
    kind: "stream",
    content: Z.stream(t),
    mediaType: e
  })
  // TODO: Raw content type for pass-through scenarios:
  // raw: (content: string, mediaType: MediaType | string): ContentType => ({
  //     kind: "raw",
  //     content,
  //     mediaType
  // })
};
G.text(
  '{"message": "Hello \\"world\\"", "path": "C:\\\\Users\\\\file.txt"}',
  "application/json"
  /* APPLICATION_JSON */
), G.json(
  { data: { type: "users", id: "1" } },
  "application/vnd.api+json"
), G.xml(
  "<soap:Envelope>...</soap:Envelope>",
  "application/soap+xml"
), G.binary(
  new Uint8Array([137, 80, 78, 71]),
  "image/png"
), G.json({ name: "John" }), G.text("Hello world");
const Sn = async (t) => {
  const e = /* @__PURE__ */ new Map();
  for (const [n, r] of t.entries())
    if (r instanceof File || r instanceof Blob) {
      const s = await r.arrayBuffer(), a = {
        kind: "file",
        filename: r instanceof File ? r.name : "unknown",
        contentType: r.type || "application/octet-stream",
        data: new Uint8Array(s)
      };
      e.has(n) ? e.get(n).push(a) : e.set(n, [a]);
    } else {
      const s = {
        kind: "text",
        value: r.toString()
      };
      e.has(n) ? e.get(n).push(s) : e.set(n, [s]);
    }
  return Array.from(e.entries());
}, En = async (t) => {
  const e = { ...t };
  if (e.content?.kind === "multipart" && e.content.content instanceof FormData) {
    const n = await Sn(
      e.content.content
    );
    e.content = {
      ...e.content,
      // Replace with the converted form data
      // SAFETY: Type assertion is necessary here because the plugin system expects
      // types similar to Map<string, FormDataValue[]> instead of FormData.
      // Then convert the `Map` to simpler nested `Array` of `Array` structure for better compatibility
      // `Maps` it seems like are serialized differently across platforms and serialization libraries,
      // while `Array` of `Array` tend to maintain more consistent behavior by the sheer ubiquity of it.
      // @ts-expect-error: This is intentional to work around SuperJSON serialization
      content: n
    };
  }
  return e;
};
function On(t) {
  return function(e) {
    var n = {};
    for (var r in e)
      bt.call(e, r) && (n[r] = t(r, e[r]));
    return n;
  };
}
function An(t) {
  return On(function(e, n) {
    return t(n);
  });
}
function Tn(t) {
  return function(e) {
    var n = {}, r = !1;
    for (var s in e)
      if (bt.call(e, s)) {
        var a = e[s];
        t(s, a) ? n[s] = a : r = !0;
      }
    return r ? n : e;
  };
}
var Rn = An;
function In(t) {
  return Tn(t);
}
const Nn = (t) => t >= 100 && t < 600, Cn = (t) => Je(
  t,
  In((e, n) => n !== void 0),
  Rn(String)
), Pn = {
  api: {
    id: "axios",
    capabilities: {
      method: /* @__PURE__ */ new Set([
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS"
      ]),
      header: /* @__PURE__ */ new Set(["stringvalue", "arrayvalue", "multivalue"]),
      content: /* @__PURE__ */ new Set([
        "text",
        "json",
        "xml",
        "form",
        "urlencoded",
        "compression"
      ]),
      auth: /* @__PURE__ */ new Set(["basic", "bearer", "apikey", "aws"]),
      security: /* @__PURE__ */ new Set([]),
      proxy: /* @__PURE__ */ new Set([]),
      advanced: /* @__PURE__ */ new Set([])
    },
    canHandle(t) {
      return this.capabilities.method.has(t.method) ? t.content && !this.capabilities.content.has(t.content.kind) ? w({
        kind: "unsupported_feature",
        feature: "content",
        message: `Content type ${t.content.kind} is not supported`,
        relay: "axios"
      }) : t.auth && !this.capabilities.auth.has(t.auth.kind) ? w({
        kind: "unsupported_feature",
        feature: "authentication",
        message: `Authentication type ${t.auth.kind} is not supported`,
        relay: "axios"
      }) : t.security?.certificates ? w({
        kind: "unsupported_feature",
        feature: "security",
        message: "Client certificates are not supported",
        relay: "axios"
      }) : t.proxy ? w({
        kind: "unsupported_feature",
        feature: "proxy",
        message: "Proxy is not supported",
        relay: "axios"
      }) : x(!0) : w({
        kind: "unsupported_feature",
        feature: "method",
        message: `Method ${t.method} is not supported`,
        relay: "axios"
      });
    },
    execute(t) {
      const e = ge.CancelToken.source(), n = {
        on: () => () => {
        },
        once: () => () => {
        },
        off: () => {
        }
      }, r = (async () => {
        try {
          const s = Date.now(), a = {
            url: t.url,
            method: t.method,
            headers: t.headers,
            params: t.params,
            data: t.content?.content,
            maxRedirects: t.meta?.options?.maxRedirects,
            timeout: t.meta?.options?.timeout,
            decompress: t.meta?.options?.decompress ?? !0,
            validateStatus: null,
            cancelToken: e.token,
            responseType: "arraybuffer"
          }, i = await ge(a), o = Date.now();
          if (!Nn(i.status))
            return w({
              kind: "version",
              message: `Invalid status code: ${i.status}`
            });
          const u = Cn(i.headers), d = u["content-type"] || u["Content-Type"] || u["CONTENT-TYPE"], O = i.data.byteLength, F = JSON.stringify(i.headers).length, C = {
            id: t.id,
            status: i.status,
            statusText: i.statusText,
            version: t.version,
            headers: u,
            body: Ot.body(i.data, d),
            meta: {
              timing: {
                start: s,
                end: o
              },
              size: {
                headers: F,
                body: O,
                total: F + O
              }
            }
          };
          return x(C);
        } catch (s) {
          return ge.isCancel(s) ? w({ kind: "abort", message: "Request cancelled" }) : ge.isAxiosError(s) ? s.code === "ECONNABORTED" ? w({
            kind: "timeout",
            message: "Request timed out",
            phase: "response"
          }) : w({
            kind: "network",
            message: s.message
          }) : w({
            kind: "network",
            message: s instanceof Error ? s.message : "Unknown error occurred",
            cause: s
          });
        }
      })();
      return {
        cancel: async () => {
          e.cancel();
        },
        emitter: n,
        response: r
      };
    }
  }
}, $n = {
  v1: Pn
};
async function At(t, e = {}, n) {
  return window.__TAURI_INTERNALS__.invoke(t, e, n);
}
var tt;
(function(t) {
  t.TEXT_PLAIN = "text/plain", t.TEXT_HTML = "text/html", t.TEXT_CSS = "text/css", t.TEXT_CSV = "text/csv", t.APPLICATION_JSON = "application/json", t.APPLICATION_LD_JSON = "application/ld+json", t.APPLICATION_XML = "application/xml", t.TEXT_XML = "text/xml", t.APPLICATION_FORM = "application/x-www-form-urlencoded", t.APPLICATION_OCTET = "application/octet-stream", t.MULTIPART_FORM = "multipart/form-data";
})(tt || (tt = {}));
async function Dn(t) {
  return await At("plugin:relay|execute", { request: t });
}
async function Ln(t) {
  return await At("plugin:relay|cancel", { requestId: t });
}
const jn = {
  api: {
    id: "desktop",
    capabilities: {
      method: /* @__PURE__ */ new Set([
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS"
      ]),
      header: /* @__PURE__ */ new Set(["stringvalue", "arrayvalue", "multivalue"]),
      content: /* @__PURE__ */ new Set([
        "text",
        "json",
        "xml",
        "form",
        "binary",
        "multipart",
        "urlencoded",
        "stream",
        "compression"
      ]),
      auth: /* @__PURE__ */ new Set(["basic", "bearer", "digest", "oauth2", "apikey"]),
      security: /* @__PURE__ */ new Set([
        "clientcertificates",
        "cacertificates",
        "certificatevalidation",
        "hostverification",
        "peerverification"
      ]),
      proxy: /* @__PURE__ */ new Set(["http", "https", "authentication", "certificates"]),
      advanced: /* @__PURE__ */ new Set([
        "retry",
        "redirects",
        "timeout",
        "cookies",
        "keepalive",
        "tcpoptions",
        "http2",
        "http3"
      ])
    },
    canHandle(t) {
      return this.capabilities.method.has(t.method) ? t.content && !this.capabilities.content.has(t.content.kind) ? w({
        kind: "unsupported_feature",
        feature: "content",
        message: `Content type ${t.content.kind} is not supported`,
        relay: "desktop"
      }) : t.auth && !this.capabilities.auth.has(t.auth.kind) ? w({
        kind: "unsupported_feature",
        feature: "authentication",
        message: `Authentication type ${t.auth.kind} is not supported`,
        relay: "desktop"
      }) : t.security?.certificates && !this.capabilities.security.has("clientcertificates") ? w({
        kind: "unsupported_feature",
        feature: "security",
        message: "Client certificates are not supported",
        relay: "desktop"
      }) : t.proxy && !this.capabilities.proxy.has(
        t.proxy.url.startsWith("https") ? "https" : "http"
      ) ? w({
        kind: "unsupported_feature",
        feature: "proxy",
        message: `Proxy protocol ${t.proxy.url.split(":")[0]} is not supported`,
        relay: "desktop"
      }) : x(!0) : w({
        kind: "unsupported_feature",
        feature: "method",
        message: `Method ${t.method} is not supported`,
        relay: "desktop"
      });
    },
    execute(t) {
      const e = {
        on: () => () => {
        },
        once: () => () => {
        },
        off: () => {
        }
      }, n = En(t).then((r) => {
        const s = {
          id: r.id,
          url: r.url,
          method: r.method,
          version: r.version,
          headers: r.headers,
          params: r.params,
          content: r.content,
          auth: r.auth,
          security: r.security,
          proxy: r.proxy,
          meta: r.meta
        };
        return Dn(s);
      }).then((r) => {
        if (r.kind === "success") {
          const s = {
            id: r.response.id,
            status: r.response.status,
            statusText: r.response.statusText,
            version: r.response.version,
            headers: r.response.headers,
            cookies: r.response.cookies,
            body: Ot.body(
              r.response.body.body,
              r.response.body.mediaType
            ),
            meta: {
              timing: {
                start: r.response.meta.timing.start,
                end: r.response.meta.timing.end
              },
              size: r.response.meta.size
            }
          };
          return x(s);
        }
        return w(r.error);
      }).catch((r) => {
        const s = {
          kind: "network",
          message: r instanceof Error ? r.message : "Unknown error occurred",
          cause: r
        };
        return w(s);
      });
      return {
        cancel: async () => {
          await Ln(t.id);
        },
        emitter: e,
        response: n
      };
    }
  }
}, Zn = {
  v1: jn
};
class Vn {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, n) {
    this.keyToValue.set(e, n), this.valueToKey.set(n, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}
class Tt {
  constructor(e) {
    this.generateIdentifier = e, this.kv = new Vn();
  }
  register(e, n) {
    this.kv.getByValue(e) || (n || (n = this.generateIdentifier(e)), this.kv.set(n, e));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(e) {
    return this.kv.getByValue(e);
  }
  getValue(e) {
    return this.kv.getByKey(e);
  }
}
class Un extends Tt {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, n) {
    typeof n == "object" ? (n.allowProps && this.classToAllowedProps.set(e, n.allowProps), super.register(e, n.identifier)) : super.register(e, n);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
}
function Wn(t) {
  if ("values" in Object)
    return Object.values(t);
  const e = [];
  for (const n in t)
    t.hasOwnProperty(n) && e.push(t[n]);
  return e;
}
function zn(t, e) {
  const n = Wn(t);
  if ("find" in n)
    return n.find(e);
  const r = n;
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    if (e(a))
      return a;
  }
}
function q(t, e) {
  Object.entries(t).forEach(([n, r]) => e(r, n));
}
function ye(t, e) {
  return t.indexOf(e) !== -1;
}
function nt(t, e) {
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (e(r))
      return r;
  }
}
class Mn {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return zn(this.transfomers, (n) => n.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
}
const Fn = (t) => Object.prototype.toString.call(t).slice(8, -1), Rt = (t) => typeof t > "u", Bn = (t) => t === null, le = (t) => typeof t != "object" || t === null || t === Object.prototype ? !1 : Object.getPrototypeOf(t) === null ? !0 : Object.getPrototypeOf(t) === Object.prototype, Ze = (t) => le(t) && Object.keys(t).length === 0, z = (t) => Array.isArray(t), Kn = (t) => typeof t == "string", Gn = (t) => typeof t == "number" && !isNaN(t), Hn = (t) => typeof t == "boolean", Xn = (t) => t instanceof RegExp, fe = (t) => t instanceof Map, he = (t) => t instanceof Set, It = (t) => Fn(t) === "Symbol", Jn = (t) => t instanceof Date && !isNaN(t.valueOf()), Nt = (t) => t instanceof Error, rt = (t) => typeof t == "number" && isNaN(t), Yn = (t) => Hn(t) || Bn(t) || Rt(t) || Gn(t) || Kn(t) || It(t), Qn = (t) => typeof t == "bigint", qn = (t) => t === 1 / 0 || t === -1 / 0, er = (t) => ArrayBuffer.isView(t) && !(t instanceof DataView), tr = (t) => t instanceof URL, Ve = (t) => t.replace(/\\/g, "\\\\").replace(/\./g, "\\."), De = (t) => t.map(String).map(Ve).join("."), ue = (t, e) => {
  const n = [];
  let r = "";
  for (let a = 0; a < t.length; a++) {
    let i = t.charAt(a);
    if (!e && i === "\\") {
      const d = t.charAt(a + 1);
      if (d === "\\") {
        r += "\\", a++;
        continue;
      } else if (d !== ".")
        throw Error("invalid path");
    }
    if (i === "\\" && t.charAt(a + 1) === ".") {
      r += ".", a++;
      continue;
    }
    if (i === ".") {
      n.push(r), r = "";
      continue;
    }
    r += i;
  }
  const s = r;
  return n.push(s), n;
};
function P(t, e, n, r) {
  return {
    isApplicable: t,
    annotation: e,
    transform: n,
    untransform: r
  };
}
const Ct = [
  P(Rt, "undefined", () => null, () => {
  }),
  P(Qn, "bigint", (t) => t.toString(), (t) => typeof BigInt < "u" ? BigInt(t) : (console.error("Please add a BigInt polyfill."), t)),
  P(Jn, "Date", (t) => t.toISOString(), (t) => new Date(t)),
  P(Nt, "Error", (t, e) => {
    const n = {
      name: t.name,
      message: t.message
    };
    return "cause" in t && (n.cause = t.cause), e.allowedErrorProps.forEach((r) => {
      n[r] = t[r];
    }), n;
  }, (t, e) => {
    const n = new Error(t.message, { cause: t.cause });
    return n.name = t.name, n.stack = t.stack, e.allowedErrorProps.forEach((r) => {
      n[r] = t[r];
    }), n;
  }),
  P(Xn, "regexp", (t) => "" + t, (t) => {
    const e = t.slice(1, t.lastIndexOf("/")), n = t.slice(t.lastIndexOf("/") + 1);
    return new RegExp(e, n);
  }),
  P(
    he,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (t) => [...t.values()],
    (t) => new Set(t)
  ),
  P(fe, "map", (t) => [...t.entries()], (t) => new Map(t)),
  P((t) => rt(t) || qn(t), "number", (t) => rt(t) ? "NaN" : t > 0 ? "Infinity" : "-Infinity", Number),
  P((t) => t === 0 && 1 / t === -1 / 0, "number", () => "-0", Number),
  P(tr, "URL", (t) => t.toString(), (t) => new URL(t))
];
function Ce(t, e, n, r) {
  return {
    isApplicable: t,
    annotation: e,
    transform: n,
    untransform: r
  };
}
const Pt = Ce((t, e) => It(t) ? !!e.symbolRegistry.getIdentifier(t) : !1, (t, e) => ["symbol", e.symbolRegistry.getIdentifier(t)], (t) => t.description, (t, e, n) => {
  const r = n.symbolRegistry.getValue(e[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), nr = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((t, e) => (t[e.name] = e, t), {}), $t = Ce(er, (t) => ["typed-array", t.constructor.name], (t) => [...t], (t, e) => {
  const n = nr[e[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(t);
});
function Dt(t, e) {
  return t?.constructor ? !!e.classRegistry.getIdentifier(t.constructor) : !1;
}
const Lt = Ce(Dt, (t, e) => ["class", e.classRegistry.getIdentifier(t.constructor)], (t, e) => {
  const n = e.classRegistry.getAllowedProps(t.constructor);
  if (!n)
    return { ...t };
  const r = {};
  return n.forEach((s) => {
    r[s] = t[s];
  }), r;
}, (t, e, n) => {
  const r = n.classRegistry.getValue(e[1]);
  if (!r)
    throw new Error(`Trying to deserialize unknown class '${e[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
  return Object.assign(Object.create(r.prototype), t);
}), jt = Ce((t, e) => !!e.customTransformerRegistry.findApplicable(t), (t, e) => ["custom", e.customTransformerRegistry.findApplicable(t).name], (t, e) => e.customTransformerRegistry.findApplicable(t).serialize(t), (t, e, n) => {
  const r = n.customTransformerRegistry.findByName(e[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(t);
}), rr = [Lt, Pt, jt, $t], st = (t, e) => {
  const n = nt(rr, (s) => s.isApplicable(t, e));
  if (n)
    return {
      value: n.transform(t, e),
      type: n.annotation(t, e)
    };
  const r = nt(Ct, (s) => s.isApplicable(t, e));
  if (r)
    return {
      value: r.transform(t, e),
      type: r.annotation
    };
}, Zt = {};
Ct.forEach((t) => {
  Zt[t.annotation] = t;
});
const sr = (t, e, n) => {
  if (z(e))
    switch (e[0]) {
      case "symbol":
        return Pt.untransform(t, e, n);
      case "class":
        return Lt.untransform(t, e, n);
      case "custom":
        return jt.untransform(t, e, n);
      case "typed-array":
        return $t.untransform(t, e, n);
      default:
        throw new Error("Unknown transformation: " + e);
    }
  else {
    const r = Zt[e];
    if (!r)
      throw new Error("Unknown transformation: " + e);
    return r.untransform(t, n);
  }
}, X = (t, e) => {
  if (e > t.size)
    throw new Error("index out of bounds");
  const n = t.keys();
  for (; e > 0; )
    n.next(), e--;
  return n.next().value;
};
function Vt(t) {
  if (ye(t, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (ye(t, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (ye(t, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
const ar = (t, e) => {
  Vt(e);
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (he(t))
      t = X(t, +r);
    else if (fe(t)) {
      const s = +r, a = +e[++n] == 0 ? "key" : "value", i = X(t, s);
      switch (a) {
        case "key":
          t = i;
          break;
        case "value":
          t = t.get(i);
          break;
      }
    } else
      t = t[r];
  }
  return t;
}, Ue = (t, e, n) => {
  if (Vt(e), e.length === 0)
    return n(t);
  let r = t;
  for (let a = 0; a < e.length - 1; a++) {
    const i = e[a];
    if (z(r)) {
      const o = +i;
      r = r[o];
    } else if (le(r))
      r = r[i];
    else if (he(r)) {
      const o = +i;
      r = X(r, o);
    } else if (fe(r)) {
      if (a === e.length - 2)
        break;
      const u = +i, d = +e[++a] == 0 ? "key" : "value", m = X(r, u);
      switch (d) {
        case "key":
          r = m;
          break;
        case "value":
          r = r.get(m);
          break;
      }
    }
  }
  const s = e[e.length - 1];
  if (z(r) ? r[+s] = n(r[+s]) : le(r) && (r[s] = n(r[s])), he(r)) {
    const a = X(r, +s), i = n(a);
    a !== i && (r.delete(a), r.add(i));
  }
  if (fe(r)) {
    const a = +e[e.length - 2], i = X(r, a);
    switch (+s == 0 ? "key" : "value") {
      case "key": {
        const u = n(i);
        r.set(u, r.get(i)), u !== i && r.delete(i);
        break;
      }
      case "value": {
        r.set(i, n(r.get(i)));
        break;
      }
    }
  }
  return t;
}, Ut = (t) => t < 1;
function We(t, e, n, r = []) {
  if (!t)
    return;
  const s = Ut(n);
  if (!z(t)) {
    q(t, (o, u) => We(o, e, n, [
      ...r,
      ...ue(u, s)
    ]));
    return;
  }
  const [a, i] = t;
  i && q(i, (o, u) => {
    We(o, e, n, [
      ...r,
      ...ue(u, s)
    ]);
  }), e(a, r);
}
function ir(t, e, n, r) {
  return We(e, (s, a) => {
    t = Ue(t, a, (i) => sr(i, s, r));
  }, n), t;
}
function or(t, e, n) {
  const r = Ut(n);
  function s(a, i) {
    const o = ar(t, ue(i, r));
    a.map((u) => ue(u, r)).forEach((u) => {
      t = Ue(t, u, () => o);
    });
  }
  if (z(e)) {
    const [a, i] = e;
    a.forEach((o) => {
      t = Ue(t, ue(o, r), () => t);
    }), i && q(i, s);
  } else
    q(e, s);
  return t;
}
const cr = (t, e) => le(t) || z(t) || fe(t) || he(t) || Nt(t) || Dt(t, e);
function ur(t, e, n) {
  const r = n.get(t);
  r ? r.push(e) : n.set(t, [e]);
}
function dr(t, e) {
  const n = {};
  let r;
  return t.forEach((s) => {
    if (s.length <= 1)
      return;
    e || (s = s.map((o) => o.map(String)).sort((o, u) => o.length - u.length));
    const [a, ...i] = s;
    a.length === 0 ? r = i.map(De) : n[De(a)] = i.map(De);
  }), r ? Ze(n) ? [r] : [r, n] : Ze(n) ? void 0 : n;
}
const Wt = (t, e, n, r, s = [], a = [], i = /* @__PURE__ */ new Map()) => {
  const o = Yn(t);
  if (!o) {
    ur(t, s, e);
    const C = i.get(t);
    if (C)
      return r ? {
        transformedValue: null
      } : C;
  }
  if (!cr(t, n)) {
    const C = st(t, n), I = C ? {
      transformedValue: C.value,
      annotations: [C.type]
    } : {
      transformedValue: t
    };
    return o || i.set(t, I), I;
  }
  if (ye(a, t))
    return {
      transformedValue: null
    };
  const u = st(t, n), d = u?.value ?? t, m = z(d) ? [] : {}, O = {};
  q(d, (C, I) => {
    if (I === "__proto__" || I === "constructor" || I === "prototype")
      throw new Error(`Detected property ${I}. This is a prototype pollution risk, please remove it from your object.`);
    const ae = Wt(C, e, n, r, [...s, I], [...a, t], i);
    m[I] = ae.transformedValue, z(ae.annotations) ? O[Ve(I)] = ae.annotations : le(ae.annotations) && q(ae.annotations, (Gt, Ht) => {
      O[Ve(I) + "." + Ht] = Gt;
    });
  });
  const F = Ze(O) ? {
    transformedValue: m,
    annotations: u ? [u.type] : void 0
  } : {
    transformedValue: m,
    annotations: u ? [u.type, O] : O
  };
  return o || i.set(t, F), F;
};
function zt(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function at(t) {
  return zt(t) === "Array";
}
function lr(t) {
  if (zt(t) !== "Object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return !!e && e.constructor === Object && e === Object.prototype;
}
function fr(t, e, n, r, s) {
  const a = {}.propertyIsEnumerable.call(r, e) ? "enumerable" : "nonenumerable";
  a === "enumerable" && (t[e] = n), s && a === "nonenumerable" && Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function ze(t, e = {}) {
  if (at(t))
    return t.map((s) => ze(s, e));
  if (!lr(t))
    return t;
  const n = Object.getOwnPropertyNames(t), r = Object.getOwnPropertySymbols(t);
  return [...n, ...r].reduce((s, a) => {
    if (a === "__proto__" || at(e.props) && !e.props.includes(a))
      return s;
    const i = t[a], o = ze(i, e);
    return fr(s, a, o, t, e.nonenumerable), s;
  }, {});
}
class _ {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new Un(), this.symbolRegistry = new Tt((n) => n.description ?? ""), this.customTransformerRegistry = new Mn(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const n = /* @__PURE__ */ new Map(), r = Wt(e, n, this, this.dedupe), s = {
      json: r.transformedValue
    };
    r.annotations && (s.meta = {
      ...s.meta,
      values: r.annotations
    });
    const a = dr(n, this.dedupe);
    return a && (s.meta = {
      ...s.meta,
      referentialEqualities: a
    }), s.meta && (s.meta.v = 1), s;
  }
  deserialize(e, n) {
    const { json: r, meta: s } = e;
    let a = n?.inPlace ? r : ze(r);
    return s?.values && (a = ir(a, s.values, s.v ?? 0, this)), s?.referentialEqualities && (a = or(a, s.referentialEqualities, s.v ?? 0)), a;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e), { inPlace: !0 });
  }
  registerClass(e, n) {
    this.classRegistry.register(e, n);
  }
  registerSymbol(e, n) {
    this.symbolRegistry.register(e, n);
  }
  registerCustom(e, n) {
    this.customTransformerRegistry.register({
      name: n,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
}
_.defaultInstance = new _();
_.serialize = _.defaultInstance.serialize.bind(_.defaultInstance);
_.deserialize = _.defaultInstance.deserialize.bind(_.defaultInstance);
_.stringify = _.defaultInstance.stringify.bind(_.defaultInstance);
_.parse = _.defaultInstance.parse.bind(_.defaultInstance);
_.registerClass = _.defaultInstance.registerClass.bind(_.defaultInstance);
_.registerSymbol = _.defaultInstance.registerSymbol.bind(_.defaultInstance);
_.registerCustom = _.defaultInstance.registerCustom.bind(_.defaultInstance);
_.allowErrorProps = _.defaultInstance.allowErrorProps.bind(_.defaultInstance);
_.serialize;
_.deserialize;
_.stringify;
_.parse;
_.registerClass;
_.registerCustom;
_.registerSymbol;
_.allowErrorProps;
var k;
(function(t) {
  t.assertEqual = (s) => {
  };
  function e(s) {
  }
  t.assertIs = e;
  function n(s) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (s) => {
    const a = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return t.objectValues(i);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(a) {
    return s[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, t.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function r(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(k || (k = {}));
var it;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(it || (it = {}));
const f = k.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), V = (t) => {
  switch (typeof t) {
    case "undefined":
      return f.undefined;
    case "string":
      return f.string;
    case "number":
      return Number.isNaN(t) ? f.nan : f.number;
    case "boolean":
      return f.boolean;
    case "function":
      return f.function;
    case "bigint":
      return f.bigint;
    case "symbol":
      return f.symbol;
    case "object":
      return Array.isArray(t) ? f.array : t === null ? f.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? f.promise : typeof Map < "u" && t instanceof Map ? f.map : typeof Set < "u" && t instanceof Set ? f.set : typeof Date < "u" && t instanceof Date ? f.date : f.object;
    default:
      return f.unknown;
  }
}, c = k.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class j extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(a) {
      return a.message;
    }, r = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          r._errors.push(n(i));
        else {
          let o = r, u = 0;
          for (; u < i.path.length; ) {
            const d = i.path[u];
            u === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(n(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], u++;
          }
        }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof j))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, k.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const s of this.issues)
      s.path.length > 0 ? (n[s.path[0]] = n[s.path[0]] || [], n[s.path[0]].push(e(s))) : r.push(e(s));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
j.create = (t) => new j(t);
const Me = (t, e) => {
  let n;
  switch (t.code) {
    case c.invalid_type:
      t.received === f.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case c.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, k.jsonStringifyReplacer)}`;
      break;
    case c.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${k.joinValues(t.keys, ", ")}`;
      break;
    case c.invalid_union:
      n = "Invalid input";
      break;
    case c.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${k.joinValues(t.options)}`;
      break;
    case c.invalid_enum_value:
      n = `Invalid enum value. Expected ${k.joinValues(t.options)}, received '${t.received}'`;
      break;
    case c.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case c.invalid_return_type:
      n = "Invalid function return type";
      break;
    case c.invalid_date:
      n = "Invalid date";
      break;
    case c.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : k.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case c.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case c.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case c.custom:
      n = "Invalid input";
      break;
    case c.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case c.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case c.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, k.assertNever(t);
  }
  return { message: n };
};
let hr = Me;
function pr() {
  return hr;
}
const mr = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: s } = t, a = [...n, ...s.path || []], i = {
    ...s,
    path: a
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: a,
      message: s.message
    };
  let o = "";
  const u = r.filter((d) => !!d).slice().reverse();
  for (const d of u)
    o = d(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: o
  };
};
function l(t, e) {
  const n = pr(), r = mr({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === Me ? void 0 : Me
      // then global default map
    ].filter((s) => !!s)
  });
  t.common.issues.push(r);
}
class E {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const s of n) {
      if (s.status === "aborted")
        return g;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const s of n) {
      const a = await s.key, i = await s.value;
      r.push({
        key: a,
        value: i
      });
    }
    return E.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const s of n) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return g;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (r[a.value] = i.value);
    }
    return { status: e.value, value: r };
  }
}
const g = Object.freeze({
  status: "aborted"
}), ie = (t) => ({ status: "dirty", value: t }), R = (t) => ({ status: "valid", value: t }), ot = (t) => t.status === "aborted", ct = (t) => t.status === "dirty", ee = (t) => t.status === "valid", ve = (t) => typeof Promise < "u" && t instanceof Promise;
var h;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(h || (h = {}));
var we = function(t, e, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}, Mt = function(t, e, n, r, s) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? s.call(t, n) : s ? s.value = n : e.set(t, n), n;
}, oe, ce;
class D {
  constructor(e, n, r, s) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const ut = (t, e) => {
  if (ee(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new j(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function y(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: s } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    const { message: u } = t;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? r ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? n ?? o.defaultError };
  }, description: s };
}
class v {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return V(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: V(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new E(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: V(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (ve(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    const r = {
      common: {
        issues: [],
        async: n?.async ?? !1,
        contextualErrorMap: n?.errorMap
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: V(e)
    }, s = this._parseSync({ data: e, path: r.path, parent: r });
    return ut(r, s);
  }
  "~validate"(e) {
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: V(e)
    };
    if (!this["~standard"].async)
      try {
        const r = this._parseSync({ data: e, path: [], parent: n });
        return ee(r) ? {
          value: r.value
        } : {
          issues: n.common.issues
        };
      } catch (r) {
        r?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((r) => ee(r) ? {
      value: r.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n?.errorMap,
        async: !0
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: V(e)
    }, s = this._parse({ data: e, path: r.path, parent: r }), a = await (ve(s) ? s : Promise.resolve(s));
    return ut(r, a);
  }
  refine(e, n) {
    const r = (s) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(s) : n;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: c.custom,
        ...r(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, s) => e(r) ? !0 : (s.addIssue(typeof n == "function" ? n(r, s) : n), !1));
  }
  _refinement(e) {
    return new re({
      schema: this,
      typeName: p.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return W.create(this, this._def);
  }
  nullable() {
    return se.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return $.create(this);
  }
  promise() {
    return Ee.create(this, this._def);
  }
  or(e) {
    return xe.create([this, e], this._def);
  }
  and(e) {
    return be.create(this, e, this._def);
  }
  transform(e) {
    return new re({
      ...y(this._def),
      schema: this,
      typeName: p.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Ge({
      ...y(this._def),
      innerType: this,
      defaultValue: n,
      typeName: p.ZodDefault
    });
  }
  brand() {
    return new Zr({
      typeName: p.ZodBranded,
      type: this,
      ...y(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new He({
      ...y(this._def),
      innerType: this,
      catchValue: n,
      typeName: p.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Ye.create(this, e);
  }
  readonly() {
    return Xe.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const gr = /^c[^\s-]{8,}$/i, yr = /^[0-9a-z]+$/, _r = /^[0-9A-HJKMNP-TV-Z]{26}$/i, vr = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, wr = /^[a-z0-9_-]{21}$/i, kr = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, xr = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, br = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Sr = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Le;
const Er = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Or = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Ar = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Tr = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Rr = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Ir = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ft = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Nr = new RegExp(`^${Ft}$`);
function Bt(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const n = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${n}`;
}
function Cr(t) {
  return new RegExp(`^${Bt(t)}$`);
}
function Pr(t) {
  let e = `${Ft}T${Bt(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function $r(t, e) {
  return !!((e === "v4" || !e) && Er.test(t) || (e === "v6" || !e) && Ar.test(t));
}
function Dr(t, e) {
  if (!kr.test(t))
    return !1;
  try {
    const [n] = t.split("."), r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || "typ" in s && s?.typ !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function Lr(t, e) {
  return !!((e === "v4" || !e) && Or.test(t) || (e === "v6" || !e) && Tr.test(t));
}
class L extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== f.string) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_type,
        expected: f.string,
        received: a.parsedType
      }), g;
    }
    const r = new E();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? l(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && l(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        br.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "email",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        Le || (Le = new RegExp(Sr, "u")), Le.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "emoji",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        vr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "uuid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "nanoid")
        wr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "nanoid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        gr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "cuid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        yr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "cuid2",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        _r.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "ulid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), l(s, {
            validation: "url",
            code: c.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "regex",
        code: c.invalid_string,
        message: a.message
      }), r.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), r.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "datetime" ? Pr(a).test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.invalid_string,
        validation: "datetime",
        message: a.message
      }), r.dirty()) : a.kind === "date" ? Nr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.invalid_string,
        validation: "date",
        message: a.message
      }), r.dirty()) : a.kind === "time" ? Cr(a).test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.invalid_string,
        validation: "time",
        message: a.message
      }), r.dirty()) : a.kind === "duration" ? xr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "duration",
        code: c.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "ip" ? $r(e.data, a.version) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "ip",
        code: c.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "jwt" ? Dr(e.data, a.alg) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "jwt",
        code: c.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "cidr" ? Lr(e.data, a.version) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "cidr",
        code: c.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "base64" ? Rr.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "base64",
        code: c.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "base64url" ? Ir.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
        validation: "base64url",
        code: c.invalid_string,
        message: a.message
      }), r.dirty()) : k.assertNever(a);
    return { status: r.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((s) => e.test(s), {
      validation: n,
      code: c.invalid_string,
      ...h.errToObj(r)
    });
  }
  _addCheck(e) {
    return new L({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...h.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...h.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...h.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...h.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...h.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...h.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...h.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...h.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...h.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...h.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...h.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...h.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...h.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: e?.offset ?? !1,
      local: e?.local ?? !1,
      ...h.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...h.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...h.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...h.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n?.position,
      ...h.errToObj(n?.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...h.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...h.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...h.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...h.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...h.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, h.errToObj(e));
  }
  trim() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
L.create = (t) => new L({
  checks: [],
  typeName: p.ZodString,
  coerce: t?.coerce ?? !1,
  ...y(t)
});
function jr(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = n > r ? n : r, a = Number.parseInt(t.toFixed(s).replace(".", "")), i = Number.parseInt(e.toFixed(s).replace(".", ""));
  return a % i / 10 ** s;
}
class te extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== f.number) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_type,
        expected: f.number,
        received: a.parsedType
      }), g;
    }
    let r;
    const s = new E();
    for (const a of this._def.checks)
      a.kind === "int" ? k.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? jr(e.data, a.value) !== 0 && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.not_finite,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, h.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, h.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, h.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, h.toString(n));
  }
  setLimit(e, n, r, s) {
    return new te({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: h.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new te({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: h.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: h.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: h.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: h.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: h.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: h.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: h.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: h.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: h.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && k.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
te.create = (t) => new te({
  checks: [],
  typeName: p.ZodNumber,
  coerce: t?.coerce || !1,
  ...y(t)
});
class pe extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== f.bigint)
      return this._getInvalidInput(e);
    let r;
    const s = new E();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return l(n, {
      code: c.invalid_type,
      expected: f.bigint,
      received: n.parsedType
    }), g;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, h.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, h.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, h.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, h.toString(n));
  }
  setLimit(e, n, r, s) {
    return new pe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: h.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new pe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: h.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: h.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: h.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: h.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: h.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
pe.create = (t) => new pe({
  checks: [],
  typeName: p.ZodBigInt,
  coerce: t?.coerce ?? !1,
  ...y(t)
});
class Fe extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== f.boolean) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: f.boolean,
        received: r.parsedType
      }), g;
    }
    return R(e.data);
  }
}
Fe.create = (t) => new Fe({
  typeName: p.ZodBoolean,
  coerce: t?.coerce || !1,
  ...y(t)
});
class ke extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== f.date) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_type,
        expected: f.date,
        received: a.parsedType
      }), g;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_date
      }), g;
    }
    const r = new E();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : k.assertNever(a);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: h.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: h.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
ke.create = (t) => new ke({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: p.ZodDate,
  ...y(t)
});
class dt extends v {
  _parse(e) {
    if (this._getType(e) !== f.symbol) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: f.symbol,
        received: r.parsedType
      }), g;
    }
    return R(e.data);
  }
}
dt.create = (t) => new dt({
  typeName: p.ZodSymbol,
  ...y(t)
});
class lt extends v {
  _parse(e) {
    if (this._getType(e) !== f.undefined) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: f.undefined,
        received: r.parsedType
      }), g;
    }
    return R(e.data);
  }
}
lt.create = (t) => new lt({
  typeName: p.ZodUndefined,
  ...y(t)
});
class ft extends v {
  _parse(e) {
    if (this._getType(e) !== f.null) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: f.null,
        received: r.parsedType
      }), g;
    }
    return R(e.data);
  }
}
ft.create = (t) => new ft({
  typeName: p.ZodNull,
  ...y(t)
});
class ht extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return R(e.data);
  }
}
ht.create = (t) => new ht({
  typeName: p.ZodAny,
  ...y(t)
});
class Be extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return R(e.data);
  }
}
Be.create = (t) => new Be({
  typeName: p.ZodUnknown,
  ...y(t)
});
class M extends v {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return l(n, {
      code: c.invalid_type,
      expected: f.never,
      received: n.parsedType
    }), g;
  }
}
M.create = (t) => new M({
  typeName: p.ZodNever,
  ...y(t)
});
class pt extends v {
  _parse(e) {
    if (this._getType(e) !== f.undefined) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: f.void,
        received: r.parsedType
      }), g;
    }
    return R(e.data);
  }
}
pt.create = (t) => new pt({
  typeName: p.ZodVoid,
  ...y(t)
});
class $ extends v {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), s = this._def;
    if (n.parsedType !== f.array)
      return l(n, {
        code: c.invalid_type,
        expected: f.array,
        received: n.parsedType
      }), g;
    if (s.exactLength !== null) {
      const i = n.data.length > s.exactLength.value, o = n.data.length < s.exactLength.value;
      (i || o) && (l(n, {
        code: i ? c.too_big : c.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), r.dirty());
    }
    if (s.minLength !== null && n.data.length < s.minLength.value && (l(n, {
      code: c.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), r.dirty()), s.maxLength !== null && n.data.length > s.maxLength.value && (l(n, {
      code: c.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, o) => s.type._parseAsync(new D(n, i, n.path, o)))).then((i) => E.mergeArray(r, i));
    const a = [...n.data].map((i, o) => s.type._parseSync(new D(n, i, n.path, o)));
    return E.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new $({
      ...this._def,
      minLength: { value: e, message: h.toString(n) }
    });
  }
  max(e, n) {
    return new $({
      ...this._def,
      maxLength: { value: e, message: h.toString(n) }
    });
  }
  length(e, n) {
    return new $({
      ...this._def,
      exactLength: { value: e, message: h.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
$.create = (t, e) => new $({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: p.ZodArray,
  ...y(e)
});
function H(t) {
  if (t instanceof b) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = W.create(H(r));
    }
    return new b({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof $ ? new $({
    ...t._def,
    type: H(t.element)
  }) : t instanceof W ? W.create(H(t.unwrap())) : t instanceof se ? se.create(H(t.unwrap())) : t instanceof K ? K.create(t.items.map((e) => H(e))) : t;
}
class b extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = k.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== f.object) {
      const d = this._getOrReturnCtx(e);
      return l(d, {
        code: c.invalid_type,
        expected: f.object,
        received: d.parsedType
      }), g;
    }
    const { status: r, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof M && this._def.unknownKeys === "strip"))
      for (const d in s.data)
        i.includes(d) || o.push(d);
    const u = [];
    for (const d of i) {
      const m = a[d], O = s.data[d];
      u.push({
        key: { status: "valid", value: d },
        value: m._parse(new D(s, O, s.path, d)),
        alwaysSet: d in s.data
      });
    }
    if (this._def.catchall instanceof M) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const m of o)
          u.push({
            key: { status: "valid", value: m },
            value: { status: "valid", value: s.data[m] }
          });
      else if (d === "strict")
        o.length > 0 && (l(s, {
          code: c.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const m of o) {
        const O = s.data[m];
        u.push({
          key: { status: "valid", value: m },
          value: d._parse(
            new D(s, O, s.path, m)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: m in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const m of u) {
        const O = await m.key, F = await m.value;
        d.push({
          key: O,
          value: F,
          alwaysSet: m.alwaysSet
        });
      }
      return d;
    }).then((d) => E.mergeObjectSync(r, d)) : E.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return h.errToObj, new b({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          const s = this._def.errorMap?.(n, r).message ?? r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: h.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new b({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new b({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new b({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new b({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: p.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new b({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    for (const r of k.objectKeys(e))
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new b({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    for (const r of k.objectKeys(this.shape))
      e[r] || (n[r] = this.shape[r]);
    return new b({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return H(this);
  }
  partial(e) {
    const n = {};
    for (const r of k.objectKeys(this.shape)) {
      const s = this.shape[r];
      e && !e[r] ? n[r] = s : n[r] = s.optional();
    }
    return new b({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    for (const r of k.objectKeys(this.shape))
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof W; )
          a = a._def.innerType;
        n[r] = a;
      }
    return new b({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Kt(k.objectKeys(this.shape));
  }
}
b.create = (t, e) => new b({
  shape: () => t,
  unknownKeys: "strip",
  catchall: M.create(),
  typeName: p.ZodObject,
  ...y(e)
});
b.strictCreate = (t, e) => new b({
  shape: () => t,
  unknownKeys: "strict",
  catchall: M.create(),
  typeName: p.ZodObject,
  ...y(e)
});
b.lazycreate = (t, e) => new b({
  shape: t,
  unknownKeys: "strip",
  catchall: M.create(),
  typeName: p.ZodObject,
  ...y(e)
});
class xe extends v {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new j(o.ctx.common.issues));
      return l(n, {
        code: c.invalid_union,
        unionErrors: i
      }), g;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const i = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const u of r) {
        const d = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, m = u._parseSync({
          data: n.data,
          path: n.path,
          parent: d
        });
        if (m.status === "valid")
          return m;
        m.status === "dirty" && !a && (a = { result: m, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((u) => new j(u));
      return l(n, {
        code: c.invalid_union,
        unionErrors: o
      }), g;
    }
  }
  get options() {
    return this._def.options;
  }
}
xe.create = (t, e) => new xe({
  options: t,
  typeName: p.ZodUnion,
  ...y(e)
});
function Ke(t, e) {
  const n = V(t), r = V(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === f.object && r === f.object) {
    const s = k.objectKeys(e), a = k.objectKeys(t).filter((o) => s.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of a) {
      const u = Ke(t[o], e[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (n === f.array && r === f.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], u = Ke(i, o);
      if (!u.valid)
        return { valid: !1 };
      s.push(u.data);
    }
    return { valid: !0, data: s };
  } else return n === f.date && r === f.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class be extends v {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = (a, i) => {
      if (ot(a) || ot(i))
        return g;
      const o = Ke(a.value, i.value);
      return o.valid ? ((ct(a) || ct(i)) && n.dirty(), { status: n.value, value: o.data }) : (l(r, {
        code: c.invalid_intersection_types
      }), g);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
be.create = (t, e, n) => new be({
  left: t,
  right: e,
  typeName: p.ZodIntersection,
  ...y(n)
});
class K extends v {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== f.array)
      return l(r, {
        code: c.invalid_type,
        expected: f.array,
        received: r.parsedType
      }), g;
    if (r.data.length < this._def.items.length)
      return l(r, {
        code: c.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), g;
    !this._def.rest && r.data.length > this._def.items.length && (l(r, {
      code: c.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((i, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new D(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(a).then((i) => E.mergeArray(n, i)) : E.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new K({
      ...this._def,
      rest: e
    });
  }
}
K.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new K({
    items: t,
    typeName: p.ZodTuple,
    rest: null,
    ...y(e)
  });
};
class Se extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== f.object)
      return l(r, {
        code: c.invalid_type,
        expected: f.object,
        received: r.parsedType
      }), g;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in r.data)
      s.push({
        key: a._parse(new D(r, o, r.path, o)),
        value: i._parse(new D(r, r.data[o], r.path, o)),
        alwaysSet: o in r.data
      });
    return r.common.async ? E.mergeObjectAsync(n, s) : E.mergeObjectSync(n, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof v ? new Se({
      keyType: e,
      valueType: n,
      typeName: p.ZodRecord,
      ...y(r)
    }) : new Se({
      keyType: L.create(),
      valueType: e,
      typeName: p.ZodRecord,
      ...y(n)
    });
  }
}
class mt extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== f.map)
      return l(r, {
        code: c.invalid_type,
        expected: f.map,
        received: r.parsedType
      }), g;
    const s = this._def.keyType, a = this._def.valueType, i = [...r.data.entries()].map(([o, u], d) => ({
      key: s._parse(new D(r, o, r.path, [d, "key"])),
      value: a._parse(new D(r, u, r.path, [d, "value"]))
    }));
    if (r.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const d = await u.key, m = await u.value;
          if (d.status === "aborted" || m.status === "aborted")
            return g;
          (d.status === "dirty" || m.status === "dirty") && n.dirty(), o.set(d.value, m.value);
        }
        return { status: n.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const d = u.key, m = u.value;
        if (d.status === "aborted" || m.status === "aborted")
          return g;
        (d.status === "dirty" || m.status === "dirty") && n.dirty(), o.set(d.value, m.value);
      }
      return { status: n.value, value: o };
    }
  }
}
mt.create = (t, e, n) => new mt({
  valueType: e,
  keyType: t,
  typeName: p.ZodMap,
  ...y(n)
});
class me extends v {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== f.set)
      return l(r, {
        code: c.invalid_type,
        expected: f.set,
        received: r.parsedType
      }), g;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (l(r, {
      code: c.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), n.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (l(r, {
      code: c.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function i(u) {
      const d = /* @__PURE__ */ new Set();
      for (const m of u) {
        if (m.status === "aborted")
          return g;
        m.status === "dirty" && n.dirty(), d.add(m.value);
      }
      return { status: n.value, value: d };
    }
    const o = [...r.data.values()].map((u, d) => a._parse(new D(r, u, r.path, d)));
    return r.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(e, n) {
    return new me({
      ...this._def,
      minSize: { value: e, message: h.toString(n) }
    });
  }
  max(e, n) {
    return new me({
      ...this._def,
      maxSize: { value: e, message: h.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
me.create = (t, e) => new me({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: p.ZodSet,
  ...y(e)
});
class gt extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
gt.create = (t, e) => new gt({
  getter: t,
  typeName: p.ZodLazy,
  ...y(e)
});
class yt extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return l(n, {
        received: n.data,
        code: c.invalid_literal,
        expected: this._def.value
      }), g;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
yt.create = (t, e) => new yt({
  value: t,
  typeName: p.ZodLiteral,
  ...y(e)
});
function Kt(t, e) {
  return new ne({
    values: t,
    typeName: p.ZodEnum,
    ...y(e)
  });
}
class ne extends v {
  constructor() {
    super(...arguments), oe.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return l(n, {
        expected: k.joinValues(r),
        received: n.parsedType,
        code: c.invalid_type
      }), g;
    }
    if (we(this, oe, "f") || Mt(this, oe, new Set(this._def.values), "f"), !we(this, oe, "f").has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return l(n, {
        received: n.data,
        code: c.invalid_enum_value,
        options: r
      }), g;
    }
    return R(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return ne.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return ne.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
oe = /* @__PURE__ */ new WeakMap();
ne.create = Kt;
class _t extends v {
  constructor() {
    super(...arguments), ce.set(this, void 0);
  }
  _parse(e) {
    const n = k.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== f.string && r.parsedType !== f.number) {
      const s = k.objectValues(n);
      return l(r, {
        expected: k.joinValues(s),
        received: r.parsedType,
        code: c.invalid_type
      }), g;
    }
    if (we(this, ce, "f") || Mt(this, ce, new Set(k.getValidEnumValues(this._def.values)), "f"), !we(this, ce, "f").has(e.data)) {
      const s = k.objectValues(n);
      return l(r, {
        received: r.data,
        code: c.invalid_enum_value,
        options: s
      }), g;
    }
    return R(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
ce = /* @__PURE__ */ new WeakMap();
_t.create = (t, e) => new _t({
  values: t,
  typeName: p.ZodNativeEnum,
  ...y(e)
});
class Ee extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== f.promise && n.common.async === !1)
      return l(n, {
        code: c.invalid_type,
        expected: f.promise,
        received: n.parsedType
      }), g;
    const r = n.parsedType === f.promise ? n.data : Promise.resolve(n.data);
    return R(r.then((s) => this._def.type.parseAsync(s, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Ee.create = (t, e) => new Ee({
  type: t,
  typeName: p.ZodPromise,
  ...y(e)
});
class re extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === p.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        l(r, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (n.value === "aborted")
            return g;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: r.path,
            parent: r
          });
          return u.status === "aborted" ? g : u.status === "dirty" || n.value === "dirty" ? ie(u.value) : u;
        });
      {
        if (n.value === "aborted")
          return g;
        const o = this._def.schema._parseSync({
          data: i,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? g : o.status === "dirty" || n.value === "dirty" ? ie(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const u = s.refinement(o, a);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? g : (o.status === "dirty" && n.dirty(), i(o.value), { status: n.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => o.status === "aborted" ? g : (o.status === "dirty" && n.dirty(), i(o.value).then(() => ({ status: n.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!ee(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => ee(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({
          status: n.value,
          value: o
        })) : i);
    k.assertNever(s);
  }
}
re.create = (t, e, n) => new re({
  schema: t,
  typeName: p.ZodEffects,
  effect: e,
  ...y(n)
});
re.createWithPreprocess = (t, e, n) => new re({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: p.ZodEffects,
  ...y(n)
});
class W extends v {
  _parse(e) {
    return this._getType(e) === f.undefined ? R(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
W.create = (t, e) => new W({
  innerType: t,
  typeName: p.ZodOptional,
  ...y(e)
});
class se extends v {
  _parse(e) {
    return this._getType(e) === f.null ? R(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
se.create = (t, e) => new se({
  innerType: t,
  typeName: p.ZodNullable,
  ...y(e)
});
class Ge extends v {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === f.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ge.create = (t, e) => new Ge({
  innerType: t,
  typeName: p.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...y(e)
});
class He extends v {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return ve(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new j(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new j(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
He.create = (t, e) => new He({
  innerType: t,
  typeName: p.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...y(e)
});
class vt extends v {
  _parse(e) {
    if (this._getType(e) !== f.nan) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: f.nan,
        received: r.parsedType
      }), g;
    }
    return { status: "valid", value: e.data };
  }
}
vt.create = (t) => new vt({
  typeName: p.ZodNaN,
  ...y(t)
});
class Zr extends v {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ye extends v {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? g : a.status === "dirty" ? (n.dirty(), ie(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? g : s.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new Ye({
      in: e,
      out: n,
      typeName: p.ZodPipeline
    });
  }
}
class Xe extends v {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (s) => (ee(s) && (s.value = Object.freeze(s.value)), s);
    return ve(n) ? n.then((s) => r(s)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xe.create = (t, e) => new Xe({
  innerType: t,
  typeName: p.ZodReadonly,
  ...y(e)
});
var p;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(p || (p = {}));
const U = L.create, Oe = te.create, wt = Fe.create, Vr = Be.create;
M.create;
const Ur = $.create, Ae = b.create;
xe.create;
be.create;
K.create;
const Wr = Se.create;
ne.create;
Ee.create;
W.create;
se.create;
Ae({
  version: Oe(),
  lastUpdated: U().datetime(),
  namespaces: Wr(
    Ae({
      name: U(),
      version: Oe(),
      createdAt: U().datetime(),
      updatedAt: U().datetime(),
      keys: Ur(U())
    })
  )
});
const Te = Ae({
  schemaVersion: Oe(),
  metadata: Ae({
    createdAt: U().datetime(),
    updatedAt: U().datetime(),
    namespace: U(),
    encrypted: wt().optional(),
    compressed: wt().optional(),
    ttl: Oe().optional()
  }),
  data: Vr()
});
function os(t, e, n) {
  return {
    async isAvailable() {
      try {
        return _n(await t.init(e));
      } catch {
        return !1;
      }
    },
    async set(r, s) {
      const a = await t.set(e, n, r, s);
      if ($e(a)) throw new Error(a.left.message);
    },
    async get(r) {
      const s = await t.get(e, n, r);
      return $e(s) ? null : s.right ?? null;
    },
    async remove(r) {
      const s = await t.remove(e, n, r);
      if ($e(s)) throw new Error(s.left.message);
    }
  };
}
class A {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
  }
  static new() {
    return A.instance || (A.instance = new A()), A.instance;
  }
  getFullKey(e, n) {
    return `${e}:${n}`;
  }
  notifyListeners(e, n, r) {
    const s = this.getFullKey(e, n);
    (this.listeners.get(s) || /* @__PURE__ */ new Set()).forEach((i) => i({ namespace: e, key: n, value: r }));
  }
  async set(e, n, r) {
    const s = Te.parse(r);
    localStorage.setItem(
      this.getFullKey(e, n),
      _.stringify(s)
    ), this.notifyListeners(e, n, s.data);
  }
  async getRaw(e, n) {
    const r = localStorage.getItem(this.getFullKey(e, n));
    if (!r) return;
    const s = _.parse(r);
    return Te.parse(s);
  }
  async get(e, n) {
    return (await this.getRaw(e, n))?.data;
  }
  async has(e, n) {
    return localStorage.getItem(this.getFullKey(e, n)) !== null;
  }
  async delete(e, n) {
    const r = await this.has(e, n);
    return r && (localStorage.removeItem(this.getFullKey(e, n)), this.notifyListeners(e, n, void 0)), r;
  }
  async clear(e) {
    e ? Object.keys(localStorage).filter(
      (r) => r.startsWith(`${e}:`)
    ).forEach((r) => localStorage.removeItem(r)) : localStorage.clear(), this.listeners.clear();
  }
  async listNamespaces() {
    const e = /* @__PURE__ */ new Set();
    return Object.keys(localStorage).forEach((n) => {
      const [r] = n.split(":");
      e.add(r);
    }), Array.from(e);
  }
  async listKeys(e) {
    return Object.keys(localStorage).filter((n) => n.startsWith(`${e}:`)).map((n) => n.replace(`${e}:`, ""));
  }
  async watch(e, n) {
    const r = this.getFullKey(e, n);
    return {
      on: (s, a) => s !== "change" ? () => {
      } : (this.listeners.has(r) || this.listeners.set(r, /* @__PURE__ */ new Set()), this.listeners.get(r).add(a), () => this.listeners.get(r)?.delete(a)),
      once: (s, a) => {
        if (s !== "change") return () => {
        };
        const i = (o) => {
          a(o), this.listeners.get(r)?.delete(i);
        };
        return this.listeners.has(r) || this.listeners.set(r, /* @__PURE__ */ new Set()), this.listeners.get(r).add(i), () => this.listeners.get(r)?.delete(i);
      },
      off: (s, a) => {
        s === "change" && this.listeners.get(r)?.delete(a);
      }
    };
  }
}
const zr = {
  api: {
    id: "browser-store",
    capabilities: /* @__PURE__ */ new Set(["permanent", "structured", "watch", "namespace"]),
    // `init` and other methods in `web` don't `storePath`
    // but having a consistent API where first param of every method
    // is the path that filteres to the "realm" makes it easier to reason around
    async init(t) {
      try {
        return x(void 0);
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async set(t, e, n, r, s) {
      try {
        const a = A.new(), o = (await a.getRaw(e, n))?.metadata.createdAt || (/* @__PURE__ */ new Date()).toISOString(), u = (/* @__PURE__ */ new Date()).toISOString(), d = {
          schemaVersion: 1,
          metadata: {
            createdAt: o,
            updatedAt: u,
            namespace: e,
            encrypted: s?.encrypt,
            compressed: s?.compress,
            ttl: s?.ttl
          },
          data: r
        };
        return await a.set(e, n, d), x(void 0);
      } catch (a) {
        return w({
          kind: "storage",
          message: a instanceof Error ? a.message : "Unknown error",
          cause: a
        });
      }
    },
    async get(t, e, n) {
      try {
        const r = A.new();
        return x(await r.get(e, n));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async has(t, e, n) {
      try {
        const r = A.new();
        return x(await r.has(e, n));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async remove(t, e, n) {
      try {
        const r = A.new();
        return x(await r.delete(e, n));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async clear(t, e) {
      try {
        return await A.new().clear(e), x(void 0);
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async listNamespaces(t) {
      try {
        const e = A.new();
        return x(await e.listNamespaces());
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async listKeys(t, e) {
      try {
        const n = A.new();
        return x(await n.listKeys(e));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async watch(t, e, n) {
      return A.new().watch(e, n);
    }
  }
}, Mr = {
  v1: zr
};
function Fr(t, e, n, r) {
  if (typeof e == "function" ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}
function Br(t, e, n, r, s) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, n), n;
}
var _e;
function Kr(t, e = !1) {
  return window.__TAURI_INTERNALS__.transformCallback(t, e);
}
async function S(t, e = {}, n) {
  return window.__TAURI_INTERNALS__.invoke(t, e, n);
}
class Gr {
  get rid() {
    return Fr(this, _e, "f");
  }
  constructor(e) {
    _e.set(this, void 0), Br(this, _e, e);
  }
  /**
   * Destroys and cleans up this resource from memory.
   * **You should not call any method on this object anymore and should drop any reference to it.**
   */
  async close() {
    return S("plugin:resources|close", {
      rid: this.rid
    });
  }
}
_e = /* @__PURE__ */ new WeakMap();
var kt;
(function(t) {
  t.WINDOW_RESIZED = "tauri://resize", t.WINDOW_MOVED = "tauri://move", t.WINDOW_CLOSE_REQUESTED = "tauri://close-requested", t.WINDOW_DESTROYED = "tauri://destroyed", t.WINDOW_FOCUS = "tauri://focus", t.WINDOW_BLUR = "tauri://blur", t.WINDOW_SCALE_FACTOR_CHANGED = "tauri://scale-change", t.WINDOW_THEME_CHANGED = "tauri://theme-changed", t.WINDOW_CREATED = "tauri://window-created", t.WEBVIEW_CREATED = "tauri://webview-created", t.DRAG_ENTER = "tauri://drag-enter", t.DRAG_OVER = "tauri://drag-over", t.DRAG_DROP = "tauri://drag-drop", t.DRAG_LEAVE = "tauri://drag-leave";
})(kt || (kt = {}));
async function Hr(t, e) {
  window.__TAURI_EVENT_PLUGIN_INTERNALS__.unregisterListener(t, e), await S("plugin:event|unlisten", {
    event: t,
    eventId: e
  });
}
async function xt(t, e, n) {
  var r;
  const s = (r = void 0) !== null && r !== void 0 ? r : { kind: "Any" };
  return S("plugin:event|listen", {
    event: t,
    target: s,
    handler: Kr(e)
  }).then((a) => async () => Hr(t, a));
}
class Re extends Gr {
  constructor(e) {
    super(e);
  }
  /**
   * Create a new Store or load the existing store with the path.
   *
   * @example
   * ```typescript
   * import { Store } from '@tauri-apps/api/store';
   * const store = await Store.load('store.json');
   * ```
   *
   * @param path Path to save the store in `app_data_dir`
   * @param options Store configuration options
   */
  static async load(e, n) {
    const r = await S("plugin:store|load", {
      path: e,
      options: n
    });
    return new Re(r);
  }
  /**
   * Gets an already loaded store.
   *
   * If the store is not loaded, returns `null`. In this case you must {@link Store.load load} it.
   *
   * This function is more useful when you already know the store is loaded
   * and just need to access its instance. Prefer {@link Store.load} otherwise.
   *
   * @example
   * ```typescript
   * import { Store } from '@tauri-apps/api/store';
   * let store = await Store.get('store.json');
   * if (!store) {
   *   store = await Store.load('store.json');
   * }
   * ```
   *
   * @param path Path of the store.
   */
  static async get(e) {
    return await S("plugin:store|get_store", { path: e }).then((n) => n ? new Re(n) : null);
  }
  async set(e, n) {
    await S("plugin:store|set", {
      rid: this.rid,
      key: e,
      value: n
    });
  }
  async get(e) {
    const [n, r] = await S("plugin:store|get", {
      rid: this.rid,
      key: e
    });
    return r ? n : void 0;
  }
  async has(e) {
    return await S("plugin:store|has", {
      rid: this.rid,
      key: e
    });
  }
  async delete(e) {
    return await S("plugin:store|delete", {
      rid: this.rid,
      key: e
    });
  }
  async clear() {
    await S("plugin:store|clear", { rid: this.rid });
  }
  async reset() {
    await S("plugin:store|reset", { rid: this.rid });
  }
  async keys() {
    return await S("plugin:store|keys", { rid: this.rid });
  }
  async values() {
    return await S("plugin:store|values", { rid: this.rid });
  }
  async entries() {
    return await S("plugin:store|entries", { rid: this.rid });
  }
  async length() {
    return await S("plugin:store|length", { rid: this.rid });
  }
  async reload(e) {
    await S("plugin:store|reload", { rid: this.rid, ...e });
  }
  async save() {
    await S("plugin:store|save", { rid: this.rid });
  }
  async onKeyChange(e, n) {
    return await xt("store://change", (r) => {
      r.payload.resourceId === this.rid && r.payload.key === e && n(r.payload.exists ? r.payload.value : void 0);
    });
  }
  async onChange(e) {
    return await xt("store://change", (n) => {
      n.payload.resourceId === this.rid && e(n.payload.key, n.payload.exists ? n.payload.value : void 0);
    });
  }
}
const T = class T {
  constructor(e) {
    this.store = null, this.listeners = /* @__PURE__ */ new Map(), this.data = {}, this.storePath = e;
  }
  static new(e) {
    if (T.instances.has(e))
      return T.instances.get(e);
    const n = new T(e);
    return T.instances.set(e, n), n;
  }
  static async closeAll() {
    const e = Array.from(T.instances.values()).map(
      (n) => n.close()
    );
    await Promise.all(e), T.instances.clear();
  }
  static async closeStore(e) {
    const n = T.instances.get(e);
    n && (await n.close(), T.instances.delete(e));
  }
  async init() {
    if (!this.store) {
      this.store = await Re.load(this.storePath);
      const e = await this.store.get("data");
      this.data = e ?? {}, this.store.onChange((n, r) => {
        r && (this.data = r, this.notifyListeners());
      });
    }
  }
  notifyListeners() {
    for (const [e, n] of this.listeners.entries()) {
      const [r, s] = e.split(":"), a = this.data[r]?.[s];
      n.forEach(
        (i) => i({
          namespace: r,
          key: s,
          value: a?.data
        })
      );
    }
  }
  async set(e, n, r) {
    if (!this.store) throw new Error("Store not initialized");
    const s = Te.parse(r);
    this.data[e] = this.data[e] || {}, this.data[e][n] = s, await this.store.set("data", this.data), await this.store.save();
  }
  async getRaw(e, n) {
    const r = this.data[e]?.[n];
    return r ? Te.parse(r) : void 0;
  }
  async get(e, n) {
    return (await this.getRaw(e, n))?.data;
  }
  async has(e, n) {
    return !!this.data[e]?.[n];
  }
  async delete(e, n) {
    if (!this.store) throw new Error("Store not initialized");
    return this.data[e]?.[n] ? (delete this.data[e][n], Object.keys(this.data[e]).length === 0 && delete this.data[e], await this.store.set("data", this.data), await this.store.save(), !0) : !1;
  }
  async clear(e) {
    if (!this.store) throw new Error("Store not initialized");
    e ? delete this.data[e] : this.data = {}, await this.store.set("data", this.data), await this.store.save();
  }
  async listNamespaces() {
    return Object.keys(this.data);
  }
  async listKeys(e) {
    return Object.keys(this.data[e] || {});
  }
  async watch(e, n) {
    const r = `${e}:${n}`;
    return {
      on: (s, a) => s !== "change" ? () => {
      } : (this.listeners.has(r) || this.listeners.set(r, /* @__PURE__ */ new Set()), this.listeners.get(r).add(a), () => this.listeners.get(r)?.delete(a)),
      once: (s, a) => {
        if (s !== "change") return () => {
        };
        const i = (o) => {
          a(o), this.listeners.get(r)?.delete(i);
        };
        return this.listeners.has(r) || this.listeners.set(r, /* @__PURE__ */ new Set()), this.listeners.get(r).add(i), () => this.listeners.get(r)?.delete(i);
      },
      off: (s, a) => {
        s === "change" && this.listeners.get(r)?.delete(a);
      }
    };
  }
  async close() {
    this.store && (await this.store.close(), this.store = null, this.data = {}, this.listeners.clear(), T.instances.delete(this.storePath));
  }
};
T.instances = /* @__PURE__ */ new Map();
let N = T;
const Xr = {
  api: {
    id: "tauri-store",
    capabilities: /* @__PURE__ */ new Set([
      "permanent",
      "structured",
      "watch",
      "namespace",
      "secure"
    ]),
    async init(t) {
      try {
        return await N.new(t).init(), x(void 0);
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async set(t, e, n, r, s) {
      try {
        const a = N.new(t), o = (await a.getRaw(e, n))?.metadata.createdAt || (/* @__PURE__ */ new Date()).toISOString(), u = (/* @__PURE__ */ new Date()).toISOString(), d = {
          schemaVersion: 1,
          metadata: {
            createdAt: o,
            updatedAt: u,
            namespace: e,
            encrypted: s?.encrypt,
            compressed: s?.compress,
            ttl: s?.ttl
          },
          data: r
        };
        return await a.set(e, n, d), x(void 0);
      } catch (a) {
        return w({
          kind: "storage",
          message: a instanceof Error ? a.message : "Unknown error",
          cause: a
        });
      }
    },
    async get(t, e, n) {
      try {
        const r = N.new(t);
        return x(await r.get(e, n));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async has(t, e, n) {
      try {
        const r = N.new(t);
        return x(await r.has(e, n));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async remove(t, e, n) {
      try {
        const r = N.new(t);
        return x(await r.delete(e, n));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async clear(t, e) {
      try {
        return await N.new(t).clear(e), x(void 0);
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async listNamespaces(t) {
      try {
        const e = N.new(t);
        return x(await e.listNamespaces());
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async listKeys(t, e) {
      try {
        const n = N.new(t);
        return x(await n.listKeys(e));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async watch(t, e, n) {
      return N.new(t).watch(e, n);
    }
  }
}, Jr = {
  v1: Xr
}, J = [];
typeof window < "u" && (window.__DIAG_LOGS__ = J, window.__dumpDiagLogs__ = () => J.join(`
`));
class Y {
  constructor() {
  }
  static new() {
    return Y.instance || (Y.instance = new Y()), Y.instance;
  }
  format(e, n, r, s) {
    const a = (/* @__PURE__ */ new Date()).toISOString(), i = s !== void 0 ? ` ${typeof s == "string" ? s : (() => {
      try {
        return JSON.stringify(s);
      } catch {
        return String(s);
      }
    })()}` : "";
    return `[${a}] [${e.toUpperCase()}] [${n}] ${r}${i}`;
  }
  log(e, n, r, s) {
    const a = this.format(e, n, r, s);
    e === "debug" ? console.debug(a) : e === "warn" ? console.warn(a) : e === "error" ? console.error(a) : console.log(a), J.push(a), J.length > 5e3 && J.splice(0, J.length - 5e3);
  }
}
const Yr = {
  api: {
    id: "browser-log",
    capabilities: /* @__PURE__ */ new Set(["console", "buffer"]),
    // web doesn't need file init, but the API is consistent
    async init(t) {
      return x(void 0);
    },
    async log(t, e, n, r, s) {
      Y.new().log(e, n, r, s);
    }
  }
}, Qr = {
  v1: Yr
}, Q = [];
typeof window < "u" && (window.__DIAG_LOGS__ = Q, window.__dumpDiagLogs__ = () => Q.join(`
`));
const qr = 500;
let de = null, je = null;
const es = async () => {
  de || (je || (je = Promise.resolve().then(() => hn).then((t) => {
    de = t.invoke;
  })), await je);
}, B = class B {
  constructor(e) {
    this.initialized = !1, this.pendingWrites = [], this.flushTimer = null, this.filename = e;
  }
  static new(e) {
    if (B.instances.has(e))
      return B.instances.get(e);
    const n = new B(e);
    return B.instances.set(e, n), n;
  }
  async init() {
    if (!this.initialized)
      try {
        await es();
        const e = new URLSearchParams(window.location.search).get("org") ?? "(none)", n = [
          "",
          "=".repeat(72),
          `LOG SESSION START  ${(/* @__PURE__ */ new Date()).toISOString()}`,
          `  org context : ${e}`,
          `  href        : ${window.location.href}`,
          `  host        : ${window.location.host}`,
          `  __KERNEL__  : ${window.__KERNEL__ ? "present" : "MISSING"}`,
          "=".repeat(72),
          ""
        ].join(`
`);
        await de("append_log", {
          filename: this.filename,
          content: n
        }), this.initialized = !0, this.pendingWrites.length > 0 && this.scheduleFlush();
      } catch (e) {
        console.warn("[kernel-log] Failed to initialize file logger:", e);
      }
  }
  async flush() {
    if (!de || this.pendingWrites.length === 0) return;
    const e = this.pendingWrites.join(`
`) + `
`, n = this.pendingWrites;
    this.pendingWrites = [];
    try {
      await de("append_log", {
        filename: this.filename,
        content: e
      });
    } catch (r) {
      this.pendingWrites = n.concat(this.pendingWrites), console.warn("[kernel-log] Failed to flush logs to disk:", r), this.scheduleFlush();
    }
  }
  scheduleFlush() {
    this.flushTimer || (this.flushTimer = setTimeout(() => {
      this.flushTimer = null, this.flush();
    }, qr));
  }
  log(e, n, r, s) {
    const a = (/* @__PURE__ */ new Date()).toISOString(), i = s !== void 0 ? ` ${typeof s == "string" ? s : (() => {
      try {
        return JSON.stringify(s);
      } catch {
        return String(s);
      }
    })()}` : "", o = `[${a}] [${e.toUpperCase()}] [${n}] ${r}${i}`;
    e === "debug" ? console.debug(o) : e === "warn" ? console.warn(o) : e === "error" ? console.error(o) : console.log(o), Q.push(o), Q.length > 5e3 && Q.splice(0, Q.length - 5e3), this.pendingWrites.push(o), this.scheduleFlush();
  }
};
B.instances = /* @__PURE__ */ new Map();
let Ie = B;
const ts = {
  api: {
    id: "tauri-log",
    capabilities: /* @__PURE__ */ new Set(["console", "file", "buffer"]),
    async init(t) {
      try {
        return await Ie.new(t).init(), x(void 0);
      } catch (e) {
        return w({
          kind: "init",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async log(t, e, n, r, s) {
      Ie.new(t).log(e, n, r, s);
    }
  }
}, ns = {
  v1: ts
};
function cs() {
  return window.__KERNEL_MODE__ || "web";
}
function us(t) {
  if (t === "desktop") {
    const e = {
      info: {
        name: "desktop-kernel",
        version: { major: 1, minor: 0, patch: 0 },
        capabilities: ["basic-io"]
      },
      io: yn.v1.api,
      relay: Zn.v1.api,
      store: Jr.v1.api,
      log: ns.v1.api
    };
    return window.__KERNEL__ = e, e;
  } else {
    const e = {
      info: {
        name: "web-kernel",
        version: { major: 1, minor: 0, patch: 0 },
        capabilities: ["basic-io"]
      },
      io: fn.v1.api,
      relay: $n.v1.api,
      store: Mr.v1.api,
      log: Qr.v1.api
    };
    return window.__KERNEL__ = e, e;
  }
}
export {
  Et as MediaType,
  Ot as body,
  G as content,
  os as extendStore,
  cs as getKernelMode,
  us as initKernel,
  En as relayRequestToNativeAdapter
};
